import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetVideoAndTagListQueryVariables = Types.Exact<{
  market: Types.Scalars['String']['input'];
}>;


export type GetVideoAndTagListQuery = { __typename?: 'Query', testimonialList: Array<{ __typename?: 'TestimonialResponse', testimonialId?: number | null, market: string, title: string, tags: string, videoThumbnailFileName: string, videoFileName: string, createdBy: string, updatedBy: string, publishDate?: string | null, stopDate?: string | null, isInUse: boolean, videoThumbnailFileUrl: string, videoFileUrl: string }>, testimonialTagList: Array<{ __typename?: 'TagResponse', tagId: number, tagName: string, market: string, isUsed: boolean, sortOrder: number, numberOfVideos: number }> };


export const GetVideoAndTagListDocument = gql`
    query GetVideoAndTagList($market: String!) {
  testimonialList(market: $market) {
    testimonialId
    market
    title
    tags
    videoThumbnailFileName
    videoThumbnailFileUrl: videoThumbnailFileName @wf_blobSignature(name: "TRIAL_MODE_ONLINE_EXPERIENCE_TESTIMONIAL_VIDEOS_THUMBNAILS_SIGNATURE")
    videoFileName
    videoFileUrl: videoFileName @wf_blobSignature(name: "TRIAL_MODE_ONLINE_EXPERIENCE_TESTIMONIAL_VIDEOS_SIGNATURE")
    createdBy
    updatedBy
    publishDate
    stopDate
    isInUse
  }
  testimonialTagList(market: $market) {
    tagId
    tagName
    market
    isUsed
    sortOrder
    numberOfVideos
  }
}
    `;

/**
 * __useGetVideoAndTagListQuery__
 *
 * To run a query within a React component, call `useGetVideoAndTagListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoAndTagListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoAndTagListQuery({
 *   variables: {
 *      market: // value for 'market'
 *   },
 * });
 */
export function useGetVideoAndTagListQuery(baseOptions: Apollo.QueryHookOptions<GetVideoAndTagListQuery, GetVideoAndTagListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoAndTagListQuery, GetVideoAndTagListQueryVariables>(GetVideoAndTagListDocument, options);
      }
export function useGetVideoAndTagListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoAndTagListQuery, GetVideoAndTagListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoAndTagListQuery, GetVideoAndTagListQueryVariables>(GetVideoAndTagListDocument, options);
        }
export type GetVideoAndTagListQueryHookResult = ReturnType<typeof useGetVideoAndTagListQuery>;
export type GetVideoAndTagListLazyQueryHookResult = ReturnType<typeof useGetVideoAndTagListLazyQuery>;
export type GetVideoAndTagListQueryResult = Apollo.QueryResult<GetVideoAndTagListQuery, GetVideoAndTagListQueryVariables>;